export class AddInvitesRequestModel {
  public invites: number;
  public members = new Array<number>();
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/member-management/member-actions/app-invites.model.ts